document.addEventListener('DOMContentLoaded', function() {

  const hamburger = document.querySelector('.hamburger');

  hamburger.addEventListener('click', function() {

    // Toggle class "is-active"
    // hamburger.classList.toggle('is-active');
    // Do something else, like open/close menu

    const headerNav = document.getElementById('header_nav');

    console.log(headerNav);

    if (headerNav) {
      const body = document.querySelector('body');

      if (!body.classList.contains('menuMobile-open')) {
        hamburger.classList.add('is-active');
        // Disable scroll
        body.classList.add('menuMobile-open');

        // jQuery(document).find('.hitechHeader_content').slideUp(200);

      } else {
        hamburger.classList.remove('is-active');
        // Disable scroll
        body.classList.remove('menuMobile-open');

        // jQuery(document).find('.hitechHeader_content').fadeIn(100);
      }
    }

  });

});
